var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5303 2.46969C21.8232 2.76258 21.8232 3.23746 21.5303 3.53035L11.5303 13.5304C11.2374 13.8232 10.7626 13.8232 10.4697 13.5304C10.1768 13.2375 10.1768 12.7626 10.4697 12.4697L20.4697 2.46969C20.7626 2.1768 21.2374 2.1768 21.5303 2.46969Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.5303 2.46969C21.7341 2.67342 21.8031 2.97584 21.7079 3.24778L15.0579 22.2478C14.9563 22.538 14.6878 22.7369 14.3806 22.7494C14.0733 22.7619 13.7895 22.5856 13.6646 22.3046L9.9818 14.0182L1.6954 10.3354C1.41439 10.2105 1.23809 9.92671 1.25063 9.61945C1.26316 9.31219 1.46199 9.04371 1.75224 8.94213L20.7522 2.29213C21.0242 2.19695 21.3266 2.26596 21.5303 2.46969ZM4.03331 9.73297L10.8546 12.7647C11.0243 12.8401 11.16 12.9757 11.2354 13.1454L14.267 19.9667L19.7775 4.2225L4.03331 9.73297Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/Send.d854dfb18150bfbea3e9567cd3041caa.svg";
export { ForwardRef as ReactComponent };